import SearchBar from '../components/SearchBar/SearchBar';
import SearchSettings from '../components/SearchSettings/SearchSettings';
import Slider from '../components/Slider/Slider';
import HamburgerMenu from '../components/HamburgerMenu/HamburgerMenu';
import VideoModal from "../components/VideoModal/VideoModal";
import Footer from "../components/Footer/Footer";
import piri_logo from "../assets/images/about/piri_logo.png";
import AdvancedSearchPage from "./AdvancedSearchPage";
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { createChatSession } from '../api';
import { useAppContext } from '../context/AppContext';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import NotificationPopup from '../components/NotificationPopup/NotificationPopup';
import { fileToBase64 } from '../utils/fileToBase64';
import '../input.css';


const MainPage = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
    const { uniId: universityId } = useAppContext();
    const { userId, uniId, kTuru } = useAppContext();
    const [isAdvancedSearchPage, setIsAdvancedSearchPage] = useState(false);
    const location = useLocation();
    const { t } = useTranslation();
    const [files, setFiles] = useState([]);         // Yüklenecek dosyalar
    const [isSending, setIsSending] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [fileProcessType, setFileProcessType] = useState('include');


    const universityLogoUrl = universityId
        ? `https://kesifaraci.com/assets/img/university/${universityId}.png`
        : null;

    // 'searchScope' eklendi ve state güncellendi
    const [searchSettings, setSearchSettings] = useState({
        tur: 'arastirma_makalesi',
        citationFormat: 'APA',
        section: 'giris',
        language: 'turkish',
        discipline: ['multidisipliner'],
        searchScope: 'all', // Eklendi
        articleOrder: 'auto',
        pageSize: '1', // Eklendi
        categories: 'article',
        startYear: null,
        endYear: null,
        mode: "text"
    });

    const navigate = useNavigate();

    const handleGuideClick = () => {
        setIsVideoModalOpen(true);
    };

    useEffect(() => {
        if (kTuru) {
            localStorage.setItem("kullanici_turu", kTuru);
        }
    }, []);

    useEffect(() => {
    }, [searchSettings]);


    const handleSearch = async (query) => {

        if ((!query?.trim()) && files.length === 0) {
            console.log('Ne metin var ne dosya, işlem iptal.');
            return;
        }

        if (files.length > 0) {
            setErrorMessage('');
            setIsSending(true);
            try {
                    let chatId = null;
                if (query?.trim()) {
                    const questionPayload = {
                        userId: userId,
                        uniId: uniId,
                        chat_id: Date.now().toString(),
                        status: 1,
                        creation_date: new Date().toISOString(),
                        name: query

                    };
                    const questionResponse = await createChatSession(questionPayload);
                    // console.log("files try question query");

                    if (questionResponse.result && questionResponse.data) {
                        navigate('/results', {
                            state: { 
                              chatId: questionResponse.data,
                              searchQuery: query, 
                              selectedFiles: files, 
                              features: searchSettings,
                              fileProcessType
                            }
                        }); 
                    } else {
                        console.warn(
                            '11a) Beklenmeyen createChatResponse yanıtı, result ya da data yok:',
                            questionResponse
                        );
                        setErrorMessage('Dosyalar yüklenirken beklenmedik bir yanıt alındı.');
                    }
                }
                
                // BURA ŞİMDİLİK DURSUN.

                // 3.3) Şimdi dosyaları response servisine yollayalım.
                //       Response servisi muhtemelen chatId’e ihtiyaç duyar.
                // const responsePayload = {
                //         userId: userId,
                //         uniId: uniId,
                //         chat_id: Date.now().toString(),
                //         status: 1,
                //         creation_date: new Date().toISOString(),
                //         name: query
                // };

                // const responseResult = await createChatSession(responsePayload);

                // if (responseResult.result && responseResult.data) {
                //     navigate('/results', {
                //         state: { 
                //           chatId: responseResult.data, 
                //           searchQuery: query, 
                //           selectedFiles: files, 
                //           features: searchSettings,
                //           fileProcessType
                //         }
                //     });                                     
                // } else {
                //     console.warn(
                //         '11a) Beklenmeyen createChatResponse yanıtı, result ya da data yok:',
                //         responseResult
                //     );
                //     setErrorMessage('Dosyalar yüklenirken beklenmedik bir yanıt alındı.');
                // }
            } catch (error) {
                console.error('12) Dosya + metin araması sırasında hata oluştu:', error);
                setErrorMessage('Dosya yükleme sırasında bir hata oluştu.');
            } finally {
                setIsSending(false);
            }

            return;
        }


        try {
            //console.log('Sadece metin araması yapılacak, query:', query);
            const chatResponse = await createChatSession({                        
                        userId: userId,
                        uniId: uniId,
                        chat_id: Date.now().toString(),
                        status: 1,
                        creation_date: new Date().toISOString(),
                        name: query

            });
            if (chatResponse.result && chatResponse.data) {
                navigate('/results', {
                    state: { 
                      chatId: chatResponse.data, 
                      searchQuery: query, 
                      features: searchSettings // burası da!
                    }
                  });
                  
            }
        } catch (error) {
            console.error('Metin araması sırasında hata:', error);
            setErrorMessage('Metin araması sırasında bir hata oluştu.');
        }
    };


    const handleSettingsApply = (newSettings) => {
        setSearchSettings(prevSettings => ({
            ...prevSettings,
            ...newSettings
        }));

        setIsSettingsOpen(false);
    };

    const handleTopicSelect = (topic) => {
        setSearchQuery(topic);
    };

    return (
        <main className="main-content">
            <div className="absolute top-0 left-0 p-4">
                <HamburgerMenu />
            </div>

            {/* Logo bölümü güncellendi */}
            <div className="flex justify-center items-center h-full space-x-6">
                <img
                    src={piri_logo}
                    alt="Piri AI Logo"
                    className="w-24"
                />
                {universityLogoUrl ? (
                    <img
                        src={universityLogoUrl}
                        alt="University Logo"
                        className="w-24"
                    />
                ) : (
                    <p> {t('Üniversite logosu yüklenemedi')}</p>
                )}
            </div>

            <h2 className="subtitle"> {t('Akademik Araştırma ve Yazım Aracı')}</h2>


            <SearchBar
                onSearch={handleSearch}
                value={searchQuery}
                onChange={setSearchQuery}
                files={files}
                setFiles={setFiles}
                searchSettings={searchSettings}
                onSettingsApply={handleSettingsApply}
                isMainPage={true}
                fileProcessType={fileProcessType}
                setFileProcessType={setFileProcessType}
            />

            <SearchSettings
                isOpen={isSettingsOpen}
                closeSettings={() => setIsSettingsOpen(false)}
                onApply={handleSettingsApply}
                defaultSettings={searchSettings}
            />

            <Slider onTopicSelect={handleTopicSelect} />

            <div className="flex justify-center items-center gap-2">
                <button onClick={handleGuideClick}
                    className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset">
                    {t('Kullanım Kılavuzu')}
                </button>
                <button
                    onClick={() => setIsAdvancedSearchPage(true)}
                    className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset">
                    {t('Gelişmiş Arama')}
                </button>
            </div>


            <AdvancedSearchPage
                isOpen={isAdvancedSearchPage}
                onClose={() => setIsAdvancedSearchPage(false)}
            />


            <VideoModal
                isOpen={isVideoModalOpen}
                onClose={() => setIsVideoModalOpen(false)}
            />
            <Footer />
            <NotificationPopup />

        </main>
    );
};

export default MainPage;